<template>
  <div>
    <b-modal
      ref="transactionModal"
      size="lg"
      header-class="header-gray"
      footer-class="footer-class"
      body-class="body-class"
      lazy
      hide-footer
      :no-enforce-focus="true"
    >
      <template #modal-title>
        Transaction Details
      </template>
      <transaction :id="transactionId"></transaction>
    </b-modal>
    <b-modal
      ref="refundVoidModal"
      size="sm"
      hide-footer
      :no-enforce-focus="true"
    >
      <template #modal-title>
        {{ refundVoidAction | title }} for {{ transaction.firstName }}
        {{ transaction.lastName }}
      </template>
      <refund-void
        lazy
        :transaction="transaction"
        :refundVoidAction="refundVoidAction"
        v-on:refundVoidModalDone="refundVoidModalDone"
      ></refund-void>
    </b-modal>

    <b-card-header class="border-0" v-if="!headless">
      <b-row>
        <b-col class="col-sm-10">
          <h3 class="mb-0">Transactions</h3>
        </b-col>
        <b-col style="text-align: right"> </b-col>
      </b-row>
    </b-card-header>

    <table class="table">
      <thead>
        <tr>
          <th style="width:50px">&nbsp;</th>
          <th>
            Date
          </th>
          <th class="align-middle" v-if="showCompany">Dentist</th>
          <th v-if="!supressPatientName">
            Patient
          </th>
          <th v-if="!supressSource">
            Source
          </th>
          <th>
            Payment Method
          </th>
          <th class="text-right">
            Amount
          </th>

          <th class="text-right">
            Action
          </th>
        </tr>
      </thead>
      <tr v-for="row in transactions" v-bind:key="row.id">
        <td class="align-middle text-center">
          <disposition
            :reason="row.reason"
            :status="row.status"
            :refundVoidType="row.refundVoidType"
            :id="row.referenceId"
          ></disposition>
        </td>

        <td class="align-middle">
          {{ row.created | moment("MM/DD/YYYY") }}<br />
          <small>{{ row.created | moment("hh:mm:ss A") }}</small>
        </td>
        <td class="align-middle" v-if="showCompany">{{ row.companyName }}</td>
        <td class="align-middle" v-if="!supressPatientName">
          <a :href="'/#/customer/' + row.customerId">
            {{ row.firstName | title }} {{ row.lastName | title }}
          </a>
        </td>
        <td class="align-middle" v-if="showCompany">
          {{ row.source.toLowerCase() }}
        </td>
        <td class="align-middle" v-if="!supressSource && !showCompany">
          <span
            v-if="row.source == 'PAYMENTPLAN' && hasRole('VIEWPAYMENTPLANS')"
            ><a
              href="#"
              @click.prevent="
                $emitter.emit('show-paymentplan', row.paymentPlanId)
              "
              >Payment Plan
            </a></span
          >
          <span
            v-if="row.source == 'PAYMENTPLAN' && !hasRole('VIEWPAYMENTPLANS')"
          >
            Payment Plan
          </span>
          <span v-if="row.source == 'MEMBERSHIP' && hasRole('VIEWMEMBERSHIPS')">
            <a
              href="#"
              @click.prevent="
                $emitter.emit(
                  'show-customer-membership-billing',
                  row.customerMembershipBillingId
                )
              "
            >
              Membership
            </a>
          </span>
          <span
            v-if="row.source == 'MEMBERSHIP' && !hasRole('VIEWMEMBERSHIPS')"
          >
            Membership
          </span>
          <span v-if="row.source == 'VIRTUALTERMINAL'">Virtual Terminal</span>
          <span v-if="row.source == 'TERMINAL'">Terminal</span>
          <span v-if="row.source == 'PAYMENTPAGE'">Payment Page</span>
          <span
            v-if="row.source == 'TEXTTOPAY' && hasRole('VIEWPAYMENTREQUESTS')"
            ><a
              href="#"
              @click.prevent="
                $emitter.emit('show-notification', row.notificationId)
              "
              >Payment Request
            </a></span
          >
          <span
            v-if="row.source == 'TEXTTOPAY' && !hasRole('VIEWPAYMENTREQUESTS')"
          >
            Payment Request
          </span>
        </td>
        <td class="align-middle" v-if="row.fundingSource == 'CARD'">
          <card-svg :cardType="row.cardType" /> {{ row.cardDescription }}
        </td>
        <td class="align-middle" v-else-if="row.fundingSource == 'CASH'">
          <img src="img/cash.svg" height="21" />
          <span class="align-top">&nbsp;&nbsp;Cash</span>
        </td>
        <td class="align-middle" v-else-if="row.fundingSource == 'CHECK'">
          <img src="img/check.svg" height="21" /><span class="align-top"
            >&nbsp;&nbsp;Check</span
          >
        </td>
        <td class="align-middle" v-else>
          {{ row.fundingSource }}
        </td>
        <td class="text-right align-middle">
          <i
            class="fa-solid fa-circle-half-stroke"
            v-if="row.refundVoidType && row.refundVoidAmount != row.amount"
            v-b-tooltip.hover
            title="Partial Refund"
          ></i>

          <transaction-amount
            v-if="row.refundVoidAmount == row.Amount || !row.refundVoidType"
            class="trans-amount"
            :amount="row.amount"
            :status="row.status"
            :refundVoidType="row.refundVoidType"
          ></transaction-amount>
          <transaction-amount
            v-else
            class="trans-amount"
            :amount="row.refundVoidAmount"
            :status="row.status"
            :refundVoidType="row.refundVoidType"
          ></transaction-amount>
        </td>

        <td class="text-right">
          <b-dropdown
            dropleft
            variant="link"
            toggle-class="text-decoration-none"
            class="p-0 m-0"
            no-caret
            size="lg"
            id="dropdown-1"
            text="Action"
            @show="setSettledAction(row)"
          >
            <template #button-content>
              <i class="fas fa-ellipsis-h"></i>
            </template>

            <template
              v-if="
                !row.refundVoidType &&
                  !row.noAction &&
                  row.fundingSource == 'CARD'
              "
            >
              <b-dropdown-item
                v-if="
                  !row.isLoaded &&
                    (hasRole('PROCESSVOID') || hasRole('PROCESSREFUND'))
                "
              >
                <LoadingSvg
                  :width="25"
                  style="margin-top:-20px; margin-bottom:-20px;margin-top:-20px;margin-bottom:-20px"
                />
              </b-dropdown-item>
              <b-dropdown-item
                v-if="row.isSettled === true && hasRole('PROCESSREFUND')"
                @click.prevent="showRefundVoid(row, 'REFUND')"
              >
                <i class="icomoon icon-status-refunded text-warning"></i
                >Refund</b-dropdown-item
              >
              <b-dropdown-item
                v-if="row.isSettled === false && hasRole('PROCESSVOID')"
                @click.prevent="showRefundVoid(row, 'VOID')"
              >
                <i class="icomoon icon-status-voided text-muted"></i
                >Void</b-dropdown-item
              >
            </template>
            <b-dropdown-item @click.prevent="showTransaction(row)">
              <i class="icomoon icon-details-system"></i>Transaction
              Details</b-dropdown-item
            >
          </b-dropdown>
        </td>
      </tr>
    </table>

    <b-pagination
      align="center"
      class="mt-3"
      v-if="showPagination"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      @change="pageChange"
    ></b-pagination>
  </div>
</template>
<script>
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";

import SortHeader from "./SortHeader.vue";
import swal from "sweetalert2";
import RefundVoid from "@/views/Components/Transactions/RefundVoid";
import Transaction from "@/views/Components/Transactions/Transaction";
import LoadingSvg from "@/views/Components/LoadingSvg.vue";
export default {
  name: "transaction-search-results",
  inject: ["hasRole"],
  props: {
    transactionUrl: { type: String, default: "/api/transaction/transactions" },
    showCompany: { type: Boolean, default: false },
    supressPatientName: false,
    supressSource: false,
    headless: false,
    supressOptions: false,
    query: {
      paymentPlanDetailId: null,
      startDate: null,
      endDate: null,
      customerKey: null,
      moduleSelected: [],
      statusSelected: [],
      notificationId: null,
    },
  },
  components: {
    "sort-header": SortHeader,
    "refund-void": RefundVoid,
    LoadingSvg,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    transaction: Transaction,
  },
  watch: {
    query: {
      immediate: true,
      async handler(newVal) {
        this.bind(1);
      },
      deep: true,
    },
  },
  mounted() {
    this.$emitter.once("bind-transactions", (e) => {
      this.bind(this.currentPage);
    });
  },
  methods: {
    refundVoidModalDone() {
      this.$refs.refundVoidModal.hide();
      this.bind(this.currentPage);
    },
    showTransaction(transaction) {
      this.transactionId = transaction.id;
      this.transaction = transaction;

      this.$refs.transactionModal.show();
    },
    getVoidRefundHover(row) {
      var self = this;
      return (
        self.$root.$options.filters.title(row.refundVoidType) +
        " " +
        self.$root.$options.filters.currency(row.refundVoidAmount / 100) +
        ".  Transaction ID : " +
        row.refundVoidReferenceId.split("-")[0]
      );
    },
    showRefundVoid(transaction, action) {
      console.log(transaction);
      var self = this;
      self.refundVoidAction = action;
      self.transaction = transaction;
      this.$refs.refundVoidModal.show();
    },

    getHeader(a) {
      return a;
    },
    sort(a) {
      var self = this;
      self.sortOption = a.prop + ":" + a.order;
      self.bind(1);
    },
    async bind(page) {
      var self = this;

      self.currentPage = page;

      var form = self.query;

      form.currentPage = page;
      form.sortOption = self.sortOption;

      if (form.notificationId) self.$emit("hideFilter");

      var r = await self.$client.post(this.transactionUrl, form);

      r.data.value.forEach((e) => {
        e.isSettled = null; // reactivity hack
        e.isLoaded = false;
        e.animate = false;

        e.noAction = false;

        e.opacity = 1;
      });

      var transactionList = r.data.value;

      this.$emit("length", transactionList.length);

      self.transactions = transactionList;
      self.rows = self.transactions[0].rows;

      self.showPagination = self.rows > 10;
    },
    setSettledAction(transaction) {
      if (
        transaction.status == "APPROVED" &&
        transaction.referenceId &&
        transaction.fundingSource == "CARD"
      ) {
        transaction.isSettled = null;
        this.isSettled(transaction);
      } else {
        transaction.noAction = true;
      }
    },
    async isSettled(transaction) {
      transaction.isLoaded = false;

      let result = await this.$client.get(
        "/api/transaction/getTransaction?id=" + transaction.referenceId,
        {
          noProgress: true,
        }
      );

      let t = this.transactions.find(
        (a) => a.referenceId == transaction.referenceId
      );

      t.isSettled = result.data.value.isSettled;

      t.isLoaded = true;
    },
    pageChange(page) {
      var self = this;

      this.bind(page);
    },
    newSort() {
      var self = this;

      self.bind(page);
    },
  },
  data() {
    return {
      refundVoidAction: null,
      selectedTransaction: null,
      showPagination: false,
      referenceId: null,
      sortOption: "Date:descending",
      rows: null,
      currentPage: 1,
      perPage: 10,
      transaction: null,
      transactionId: null,
      transactions: [],
    };
  },
};
</script>
<style>
.trans-amount {
  display: inline-block;
}
.fa-circle-half-stroke {
  font-size: 0.8em;
  position: relative;
  top: -1px;
  padding-right: 5px;
  color: #fb6340;
}
</style>
